

const esp = {
  title: "Generador de Firmas de Correo Electrónico",
  name: "Nombre",
  surname: "Apellido",
  position: "Cargo",
  codigo: "Codigo",
  phone: "Teléfono / Celular",
  location: "Región",
  empresa: "Compañía",
  help: "HAGA CLIC EN EL BOTÓN COPIAR FIRMA Y PEGUE EN OUTLOOK.",
  confirm: "Establecer Firma",
  copy: "Copiar firma",
  copyConfirm: "Firma copiada",
};

const port = {
  title: "Gerador de Assinatura de E-mail",
  name: "Nome",
  surname: "Sobrenome",
  position: "Cargo",
  codigo: "Código",
  phone: "Telefone / Celular",
  location: "Região",
  empresa: "Companhia",
  help: "CLIQUE NO BOTÃO COPIAR ASSINATURA E COLE NO OUTLOOK.",
  confirm: "definir assinatura",
  copy: "Copiar assinatura",
  copyConfirm: "Assinatura copiada",
};

export default function getIdioma (idioma) {
  if (idioma === 'esp') {
    return esp;
  }
  else return port;
};